// --- Date & Time Library
import moment from 'moment';

/**
 * Returns the value if it is not null, undefined, or an empty string.
 * Otherwise, returns '--'.
 * If formatDate is true, formats the value as a date string.
 *
 * @param {any} value - The value to check.
 * @param {boolean} formatDate - If true, formats the value as a date string.
 * @return {string} - The formatted value or '--'.
 */
export function valueOrDefault(value, formatDate = false) {
    if (formatDate) {
        return value ? moment(value).format('YYYY-MM-DD') : '--';
    } else {
        return value && value.toString().trim() !== '' ? value : '--';
    }
}
